import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTips = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 20H11C11 21.1 10.1 22 9 22C7.9 22 7 21.1 7 20ZM5 18C5 18.55 5.45 19 6 19H12C12.55 19 13 18.55 13 18C13 17.45 12.55 17 12 17H6C5.45 17 5 17.45 5 18ZM16.5 9.5C16.5 13.32 13.84 15.36 12.73 16H5.27C4.16 15.36 1.5 13.32 1.5 9.5C1.5 5.36 4.86 2 9 2C13.14 2 16.5 5.36 16.5 9.5ZM21.37 7.37L20 8L21.37 8.63L22 10L22.63 8.63L24 8L22.63 7.37L22 6L21.37 7.37ZM19 6L19.94 3.94L22 3L19.94 2.06L19 0L18.06 2.06L16 3L18.06 3.94L19 6Z" })
});
export default SvgTips;
